import React from "react";

function NoDataFound() {
  return (
    <div className="col-12 mb-4">
      <div className="card text-center">
        <div className="card-body">
          <p>No data available</p>
        </div>
      </div>
    </div>
  );
}

export default NoDataFound;
